import React, { useEffect, useState } from "react";
import Popover from "@material-ui/core/Popover";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import s from "./styles.module.css";
import { InputV2 } from "../InputV2/InputV2";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import { Button, CircularProgress, TextField } from "@material-ui/core";

export const SelectV3WithModesOfSearch = ({
  values,
  name,
  onChange,
  options,
  emptyValue,
  showSelectedNumberOnValue,
  optionsLabel,
  searchRequest,
  userSearchMode,
  setUserSearchMode,
  onChangeDob,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [optionsState, setOptionsState] = useState(options);
  const [loading, setLoading] = useState(false); // New state to handle loading
  const today = new Date().toISOString().split("T")[0]; // e.g. "2025-11-04"
  const [dobFrom, setDobFrom] = useState(today);
  const [dobTo, setDobTo] = useState(today);

  useEffect(() => {
    setOptionsState(options);
  }, [options]);

  useEffect(() => {
    let debounceTimer;
    if (searchValue.length) {
      const debounceSearch = async () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(async () => {
          setLoading(true);
          const resp = await searchRequest(searchValue);
          console.log();
          setOptionsState(resp);
          setLoading(false);
        }, 1000);
      };
      debounceSearch();
    } else {
      setOptionsState(options);
    }

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchValue]);

  const handleClick = (event) => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
    setAnchorEl(event.currentTarget);
  };

  const handleOptionClick = (value) => {
    onChange(name, value);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // setSearchValue("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const renderLabel = () => {
    const firstHit = optionsState.find(
      (el) => el.userName === values[0].userName
    )?.userName;
    if (firstHit) {
      return firstHit;
    } else {
      return options.find((el) => el.userName === values[0].userName)?.userName;
    }
  };

  return (
    <div className={s.container}>
      <div
        style={{ fontSize: "14px" }}
        className={`${s.selectWrapper} ${
          values.length ? s.selectActive : s.selectInActive
        } ${isAnimating ? s.animateButton : ""}`}
        onClick={handleClick}
      >
        <div className={s.selectValue}>
          <span>
            {values.length ? (
              showSelectedNumberOnValue ? (
                <>
                  <span
                    style={{
                      backgroundColor: "#E2D2FC",
                      padding: "2px 8px",
                      borderRadius: "14px",
                      marginRight: "5px",
                    }}
                  >
                    {values.length}
                  </span>
                  {emptyValue}
                </>
              ) : (
                `${renderLabel()} ${
                  values.length > 1 ? `+${values.length - 1}` : ""
                }`
              )
            ) : (
              emptyValue
            )}
          </span>
          <KeyboardArrowDownIcon />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: {
            minWidth: "200px",
            marginTop: "10px",
            borderRadius: "10px",
          },
        }}
      >
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              padding: "5px",
            }}
          >
            <div
              style={{
                padding: "10px",
                ...(userSearchMode === "email"
                  ? {
                      color: "#30077c",
                      borderBottom: "#30077c 2px solid",
                    }
                  : {}),
              }}
              onClick={() => setUserSearchMode("email")}
            >
              Email Search
            </div>
            <div
              style={{
                padding: "10px",
                ...(userSearchMode === "dob"
                  ? {
                      color: "#30077c",
                      borderBottom: "#30077c 2px solid",
                    }
                  : {}),
              }}
              onClick={() => setUserSearchMode("dob")}
            >
              DOB Search
            </div>
          </div>
          {userSearchMode === "email" && (
            <div className={s.options}>
              <div className={s.optionsLabel}>{optionsLabel}</div>

              <div className={s.searchContainer}>
                <InputV2
                  onChange={(name, value) => setSearchValue(value)}
                  name="search"
                  value={searchValue}
                  placeholder="Search"
                  disabled={false}
                />
              </div>

              {loading ? (
                <div className={s.loadingIcon}>
                  <CircularProgress
                    style={{ display: loading ? "block" : "none" }}
                  />
                </div>
              ) : (
                optionsState.map((el) => (
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                    }}
                    className={s.option}
                    key={el.userName}
                    onClick={() => {
                      handleOptionClick({
                        userName: el.userName,
                        email: el.email,
                        userId: el.userId,
                      });
                    }}
                  >
                    {values.length &&
                    values.findIndex((fnd) => fnd.userId === el.userId) !==
                      -1 ? (
                      <CheckBoxOutlinedIcon style={{ color: "#4009A5" }} />
                    ) : (
                      <CheckBoxOutlineBlankOutlinedIcon
                        style={{ color: "#4009A5" }}
                      />
                    )}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div>{el.userName}</div>
                      <div style={{ fontSize: "smaller", color: "gray" }}>
                        {el.email}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          {userSearchMode === "dob" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {/* FROM DATE FIELD */}
                  <TextField
                    id="from-date"
                    label="From"
                    type="date"
                    value={dobFrom}
                    onChange={(e) => setDobFrom(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    style={{ marginBottom: "10px" }}
                  />

                  {/* TO DATE FIELD */}
                  <TextField
                    id="to-date"
                    label="To"
                    type="date"
                    value={dobTo}
                    onChange={(e) => setDobTo(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexDirection: "row-reverse",
                  marginTop: "15px",
                }}
              >
                <div className={s.clearButtonContainer}>
                  <span
                    className={s.applyDobButton}
                    onClick={() => {
                      const formatToMMDDYYYY = (dateStr) => {
                        const [year, month, day] = dateStr.split("-");
                        return `${month}/${day}/${year}`;
                      };

                      const dobStart = formatToMMDDYYYY(dobFrom);
                      const dobEnd = formatToMMDDYYYY(dobTo);

                      onChangeDob({ dobStart, dobEnd });
                    }}
                  >
                    Apply
                  </span>
                </div>

                <div className={s.clearButtonContainer}>
                  <span
                    className={
                      dobFrom || dobTo ? s.clearButton : s.inactiveClearButton
                    }
                    onClick={() => {
                      const today = new Date().toISOString().split("T")[0];
                      setDobFrom(today);
                      setDobTo(today);
                      onChangeDob(null);
                    }}
                  >
                    Clear
                  </span>
                </div>
              </div>
            </div>
          )}
        </>
      </Popover>
    </div>
  );
};
